<template>
    <div @click="clickHandler"
         class="button py-2 px-6 rounded-full text-center font-bold inline-block border-2 border-white cursor-pointer"
         :class="classList">
      <slot></slot>
    </div>
</template>

<script>
export default {
  name: "csf-button",
  props: ["state", "type", "disabled"],
  computed: {
    classList() {
      let classes = [];
      if (this.type === "primary") {
        classes = ["bg-white", "text-brand"];
      } else {
        classes = ["bg-brand", "text-white"];
      }
      if (this.disabled) {
        classes.push("opacity-50");
      }
      return classes;
    }
  },
  methods: {
    clickHandler() {
      if (this.state != "disabled") this.$emit("click");
    }
  }
};
</script>



// WEBPACK FOOTER //
// csf-button.vue?7008113b